import { useEffect } from "react";
import { TelemetryLogger } from "./telemetry";

/** React hook that flushes telemetry logs before page unload. Call this in your root App component. */
export function useTelemetryFlush() {
  useEffect(() => {
    const handleBeforeUnload = () => {
      TelemetryLogger.flush();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
}
